<template>
  <div>
    <a-table size="middle" :scroll="{ x: 1200 }" :pagination="false" :columns="columns" :data-source="tableData" row-key="id" :loading="loading" @change="handleTableChange">
      <span slot="taskId" slot-scope="text, record"> {{ `TS-${record.id}` }} </span>
      <span slot="status" slot-scope="text, record">
        <task-status-edit :task-id="record.id" :next-status="record.next_status" :status="record.status" @change="getTaskList" />
      </span>
      <span slot="priority" slot-scope="text, record">
        <task-priority-edit :value="record.priority" :task-id="record.id" @change="getTaskList" />
      </span>
      <span slot="creator" slot-scope="text, record">{{ record.creator.nickname }} </span>
      <span slot="tag" slot-scope="text, record">
        <a-popover placement="topLeft">
          <template slot="content">
            <a-tag v-for="(tag, index) in filteredTags(record.tags)" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
          </template>
          <template slot="title">
            <span>标签</span>
          </template>
          <a-tag v-for="(tag, index) in filteredTags(record.tags)" :key="index" :color="tag.color">{{ tag.name }}</a-tag>
        </a-popover>
      </span>
      <span slot="handlers" slot-scope="text, record">
        <span v-if="handlers(record)">
          <a-popover placement="topLeft">
            <template slot="content">
              <span v-for="handler in handlers(record)" :key="handler.id">
                <a-avatar :size="20" :src="handler.avatar_url" /> <span class="nickname">{{ handler.nickname }} </span>
              </span>
            </template>
            <span slot="title">处理人</span>
            <span v-for="handler in handlers(record)" :key="handler.id">{{ handler.nickname }}; </span>
          </a-popover>
        </span>
        <span v-else> -- </span>
      </span>
      <span slot="preStartTime" slot-scope="text, record">
        <task-date-edit :data-source="record" item-name="pre_start_time" @change="getTaskList" />
      </span>
      <span slot="preEndTime" slot-scope="text, record">
        <task-date-edit :data-source="record" item-name="pre_end_time" @change="getTaskList" />
      </span>
      <span slot="point" slot-scope="text, record">
        <task-point-edit :value="record.point" :task-id="record.id" @change="getTaskList" />
      </span>
      <span slot="taskName" slot-scope="text, record">
        <task-name-edit :name="record.name" :task-id="record.id" @change="getTaskList" />
      </span>
      <span slot="action" slot-scope="text, record">
        <a-dropdown placement="bottomCenter">
          <a-icon type="more" />
          <a-menu slot="overlay">
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onEdit(record)"><a-icon type="edit" /> 编辑</a>
            </a-menu-item>
            <a-menu-item>
              <a class="ant-dropdown-link" @click="onDelete(record)"><a-icon type="delete" /> 删除</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </span>
    </a-table>
    <task-edit ref="taskEditRef" @close="close" />
    <task-delete-confirm ref="taskDeleteRef" @ok="getTaskList" />
  </div>
</template>
<script>
import { taskList } from '@/api/project/task';
import { taskStatus, taskPrioritys } from '@/utils/dictionary';

import TaskEdit from '@/pages/project/task/components/TaskEdit';
import TaskDateEdit from '@/pages/project/task/components/TaskDateEdit';
import TaskNameEdit from '@/pages/project/task/components/TaskNameEdit';
import TaskPointEdit from '@/pages/project/task/components/TaskPointEdit';
import TaskStatusEdit from '@/pages/project/task/components/TaskStatusEdit';
import TaskPriorityEdit from '@/pages/project/task/components/TaskPriorityEdit';
import TaskDeleteConfirm from '@/pages/project/task/components/TaskDeleteConfirm';

const columns = [
  {
    key: 'action',
    align: 'center',
    width: 20,
    scopedSlots: { customRender: 'action' }
  },
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 94,
    scopedSlots: { customRender: 'taskId' }
  },
  {
    title: '任务名称',
    dataIndex: 'name',
    key: 'name',
    width: 480,
    scopedSlots: { customRender: 'taskName' }
  },
  {
    title: '处理人',
    dataIndex: 'handlers',
    key: 'handlers',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'handlers' }
  },
  {
    title: '优先级',
    dataIndex: 'priority',
    key: 'priority',
    sorter: true,
    width: 100,
    scopedSlots: { customRender: 'priority' }
  },
  {
    title: '状态',
    dataIndex: 'status',
    key: 'status',
    width: 120,
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '标签',
    dataIndex: 'tag',
    key: 'tag',
    width: 140,
    scopedSlots: { customRender: 'tag' }
  },
  {
    title: 'TaskPoint',
    dataIndex: 'point',
    key: 'point',
    width: 108,
    scopedSlots: { customRender: 'point' }
  },
  {
    title: '计划开始时间',
    dataIndex: 'pre_start_time',
    key: 'pre_start_time',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'preStartTime' }
  },
  {
    title: '计划结束时间',
    dataIndex: 'pre_end_time',
    key: 'pre_end_time',
    sorter: true,
    width: 120,
    scopedSlots: { customRender: 'preEndTime' }
  },
  {
    title: '完成时间',
    dataIndex: 'completed_time',
    key: 'completed_time',
    sorter: true,
    width: 168
  },
  {
    title: '创建人',
    dataIndex: 'creator',
    key: 'creator',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'creator' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    width: 168
  },
  {
    title: '更新时间',
    dataIndex: 'updated_time',
    key: 'updated_time',
    width: 168
  }
];
export default {
  components: { TaskEdit, TaskStatusEdit, TaskDateEdit, TaskPointEdit, TaskNameEdit, TaskPriorityEdit, TaskDeleteConfirm },
  props: {
    storyId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      columns,
      taskStatus,
      taskPrioritys,
      tagCounts: {},
      tagData: [],
      loading: false,
      tableData: [],
      projectId: parseInt(this.$route.params.project_id) || null,
      filterForm: {
        sort_field: null,
        sort: null,
        page_size: null,
        page_number: 1
      },
      detailVisible: false
    };
  },
  computed: {
    handlers() {
      return record => {
        return record.handlers ? record.handlers.filter(item => item.role === 3) : null;
      };
    }
  },
  created() {
    this.getTaskList();
  },
  methods: {
    filteredTags(tags) {
      const uniqueTags = tags.filter((tag, index) => {
        return tags.findIndex(t => t.id === tag.id) === index;
      });

      const tagCounts = tags.reduce((counts, tag) => {
        counts[tag.id] = (counts[tag.id] || 0) + 1;
        return counts;
      }, {});

      return uniqueTags.map(tag => {
        const count = tagCounts[tag.id];
        const processedTag = { ...tag }; // 创建一个新对象来保存处理后的标签
        if (count > 1) {
          processedTag.name = processedTag.name + count + '次';
        }
        return processedTag;
      });
    },
    getTaskList() {
      this.loading = true;
      taskList({ ...this.filterForm, requirement_id: this.storyId, project_id: this.projectId })
        .then(res => {
          this.tableData = res.data.items;
          this.loading = false;
          this.$emit('update', 'taskNum', res.data.total);
        })
        .catch(() => {
          this.loading = false;
        });
    },

    /**
     * 点击添加任务
     */
    onAdd() {
      this.$nextTick(() => {
        this.$refs['taskEditRef'].onOpen(null, {});
      });
    },

    /**
     * 点击编辑
     * @param {*} record
     */
    onEdit(record) {
      this.$nextTick(() => {
        this.$refs['taskEditRef'].onOpen(record.id, record);
      });
    },
    onDelete(record) {
      this.$nextTick(() => {
        this.$refs.taskDeleteRef.onOpen(record.id, record.project.id);
      });
    },

    handleTableChange(_pagination, _, sorter) {
      this.filterForm.sort_field = sorter.field;
      this.filterForm.sort = sorter.order === 'ascend' ? 'asc' : 'desc';
      this.getTaskList();
    },

    close() {
      this.detailVisible = false;
      this.getTaskList();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  margin-bottom: 8px;
  display: flex;
  .ant-form-item-control-wrapper {
    flex: 1;
  }
}
.filter-data {
  margin-top: 16px;
}
</style>
